
import React from 'react';

const SwayamPortal = () => {
  return (
    <div className="swayam-portal-container">
      <h2>SWAYAM Portal</h2>
      <p>
        SWAYAM (Study Webs of Active-learning for Young Aspiring Minds) is an initiative by the Government of India designed to achieve the three cardinal principles of Education Policy: access, equity and quality. The objective of this effort is to take the best teaching learning resources to all, including the most disadvantaged.
      </p>
      <p>
        Our institute encourages students and faculty to utilize the resources available on the SWAYAM portal for enhanced learning and professional development.
      </p>
      <p><a href="https://swayam.gov.in/" target="_blank" rel="noopener noreferrer">Visit the SWAYAM Portal</a></p>
    </div>
  );
};

export default SwayamPortal;